module.exports = __webpack_public_path__ + "static/media/no_events.13b3216f.png";